/**
 * FOUC on-fully-loaded make the page visible
 *
 * @param {boolean} [enableDebug=false] - Enable debugging output
 */
export default (enableDebug = false) => {
	const debug = enableDebug;
	const noscriptElements = document.querySelectorAll('noscript');

	// Update the <html> element
	document.documentElement.style.visibility = 'visible';

	// Remove the <noscript>, since it's no longer applicable
	noscriptElements.forEach(noscript => {
		if (noscript.innerHTML.trim() === '<style>html{visibility:visible;}</style>') {
			noscript.remove();
			if (debug) console.log('FOUC <noscript> element removed');
		}
	});

	if (debug) console.log('FOUC visibility param updated');
};
